module.exports = __webpack_public_path__ + "front/img/39.7425ca40.png";